import { jsx } from "react/jsx-runtime";
import CommitIcon from "@mui/icons-material/Commit";
import { validateTidalLicense } from "../../base/index.js";
function Commit(props) {
  return /* @__PURE__ */ jsx(
    CommitIcon,
    {
      "data-testid": "Commit",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Commit",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Commit.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Commit"
};
validateTidalLicense();
export {
  Commit
};
//# sourceMappingURL=Commit.js.map
